import { config } from "src/config";
import { GoogleToken } from "src/types/googleAuthentication";
import Http from "./api.service";
import LogService from "./log.service";

const AuthService = () => {
  const api = Http(true, config().baseServiceProviderUrl).instance;

  const getToken = (code: string) => {
    return api
      .post<GoogleToken>("/api/authentication/token", { code })
      .then((resp) => resp.data);
  };

  const refreshToken = (refreshToken: string) => {
    return api
      .post<GoogleToken>("/authentication/refresh", {
        refresh_token: refreshToken,
      })
      .then((resp) => resp.data);
  };

  const getUser = async () => {
    return await api.get("/api/user").then((response) => {
      return response.data;
    });
  };

  const logIn = () => {
    window.location.replace(config().baseServiceProviderUrl + "/saml/login");
  };

  const logOut = (userEmailAddress: string, isAffiliate?: boolean) => {
    if (isAffiliate) {
      window.location.replace(config().baseServiceProviderUrl + "/saml/logout");
    } else {
      LogService()
        .postLog({
          action_type: "LOGOUT",
          log_date: new Date().toISOString(),
          tp_email_id: userEmailAddress,
        })
        .then(() => {
          window.location.replace(
            config().baseServiceProviderUrl + "/saml/logout"
          );
        });
    }
  };

  return { getUser, logIn, logOut, getToken };
};

export default AuthService;
